import { useCallback, useEffect } from 'react';
import { debounce } from 'underscore';

import { scaleRecaptcha } from '../helpers';

export const useRecaptchaScale = (nodeRef) => {
    const changeScale = useCallback(() => scaleRecaptcha(nodeRef.current), [nodeRef]);

    useEffect(() => {
        const onRotate = debounce(changeScale, 300);

        scaleRecaptcha(nodeRef.current);
        window.addEventListener('orientationchange', onRotate);

        return () => {
            window.removeEventListener('orientationchange', onRotate);
        };
    }, [nodeRef, changeScale]);

    return changeScale;
};
